import gsap from "gsap";
import Utils from "./Utility/Utils";
import { PAGE_COUNTRY_SCORE_CARD, PAGE_FRAMEWORK, PAGE_KEY_INSIGHTS, PAGE_POLICY_IMPLICATIONS, PAGE_POLICY_SIMULATOR } from "./constants";

export default class SubPage {
    // Step 1: Create static properties to hold the instance and track the current page
    static instance;
    static currentPage = null;  // Track the current page globally

    constructor() {
        // Ensure the class is only initialized once
        if (SubPage.instance) {
            return SubPage.instance;
        }

        SubPage.instance = this; // Save the instance

        this.homePage = document.querySelector('.main-pages #homepage');
        this.countryScoreCard = document.querySelector('.main-pages #country-scorecard');
        this.policySimulator = document.querySelector('.main-pages #policy-simulator');
        this.framekWork = document.querySelector('.main-pages #framework');
        this.policyImplications = document.querySelector('.main-pages #policy-implications');
        this.keyInsights = document.querySelector('.main-pages #key-insights');


        this.countryScoreCardTL = gsap.timeline({ paused: true })
            .to(this.countryScoreCard, {
                duration: 1,
                autoAlpha: 1,
                onStart: () => this.countryScoreCard.classList.add('active'),
                onReverseComplete: () => this.countryScoreCard.classList.remove('active')
            })


        this.policySimulatorTL = gsap.timeline({ paused: true })
            .to(this.policySimulator, {
                duration: 1,
                autoAlpha: 1,
                onStart: () => this.policySimulator.classList.add('active'),
                onReverseComplete: () => this.policySimulator.classList.remove('active')
            })


        this.framekWorkTL = gsap.timeline({ paused: true })
            .to(this.framekWork, {
                duration: 1,
                autoAlpha: 1,
                onStart: () => this.framekWork.classList.add('active'),
                onReverseComplete: () => this.framekWork.classList.remove('active')
            })


        this.policyImplicationsTL = gsap.timeline({ paused: true })
            .to(this.policyImplications, {
                duration: 1,
                autoAlpha: 1,
                onStart: () => this.policyImplications.classList.add('active'),
                onReverseComplete: () => this.policyImplications.classList.remove('active')
            });


        this.keyInsightsTL = gsap.timeline({ paused: true })
            .to(this.keyInsights, {
                duration: 1,
                autoAlpha: 1,
                onStart: () => this.keyInsights.classList.add('active'),
                onReverseComplete: () => this.keyInsights.classList.remove('active')
            })

    }

    // These methods will control the animations and update the current page
    showCountryScoreCardPage() {
        this.countryScoreCardTL.restart();
        SubPage.currentPage = PAGE_COUNTRY_SCORE_CARD;  // Update the global current page
    }

    hideCountryScoreCardPage() {
        this.countryScoreCardTL.timeScale(2).reverse();
        SubPage.currentPage = null;  // Reset when the page is hidden
    }

    showPolicySimulatorPage() {
        this.policySimulatorTL.restart();
        SubPage.currentPage = PAGE_POLICY_SIMULATOR;  // Update the global current page
    }

    hidePolicySimulatorPage() {
        this.policySimulatorTL.timeScale(2).reverse();
        SubPage.currentPage = null;  // Reset when the page is hidden
    }

    showFramworkPage() {
        this.framekWorkTL.restart();
        SubPage.currentPage = PAGE_FRAMEWORK;  // Update the global current page
    }

    hideFramworkPage() {
        this.framekWorkTL.timeScale(2).reverse();
        SubPage.currentPage = null;  // Reset when the page is hidden
    }


    showPolicyImplicationsPage() {
        this.policyImplicationsTL.restart();
        SubPage.currentPage = PAGE_POLICY_IMPLICATIONS;  // Update the global current page
    }

    hidePolicyImplicationsPage() {
        this.policyImplicationsTL.timeScale(2).reverse();
        SubPage.currentPage = null;  // Reset when the page is hidden
    }

    showKeyInsightsPage() {
        this.keyInsightsTL.restart();
        SubPage.currentPage = PAGE_KEY_INSIGHTS;  // Update the global current page
    }

    hideKeyInsightsPage() {
        this.keyInsightsTL.timeScale(2).reverse();
        SubPage.currentPage = null;  // Reset when the page is hidden
    }


    resetAll() {
        this.countryScoreCardTL.timeScale(2).reverse();
        this.policySimulatorTL.timeScale(2).reverse();
        this.framekWorkTL.timeScale(2).reverse();
        this.policyImplicationsTL.timeScale(2).reverse();
        this.keyInsightsTL.timeScale(2).reverse();
        this.homePage.classList.add('active')
    }


    // Helper function to handle the active state for both desktop and mobile nav links
    static handleActiveStateForNavLinks(linksArray, linkIndex = null) {
        // Remove active class from all links
        linksArray.forEach(link => link.classList.remove('active'));

        // If linkIndex is provided, add 'active' to the specified link
        if (linkIndex !== null) {
            linksArray[linkIndex].classList.add('active');
        } else {
            // Map current menu page to the link index
            let menuLinkMapping 
            if(window.innerWidth <= 992){
                menuLinkMapping = {
                    [PAGE_COUNTRY_SCORE_CARD]: 1,
                    [PAGE_POLICY_SIMULATOR]: 2,
                    [PAGE_FRAMEWORK]: 3
                };
            } else {
                menuLinkMapping = {
                    [PAGE_COUNTRY_SCORE_CARD]: 2,
                    [PAGE_POLICY_SIMULATOR]: 3,
                    [PAGE_FRAMEWORK]: 4
                };
            }

            // Get the current menu and default to the first link if no match is found
            const currentPage = window.menuHistory.getCurrentMenu();
            const indexToActivate = menuLinkMapping[currentPage] || 1;

            // Add 'active' class to the appropriate link based on the current menu
            linksArray[indexToActivate].classList.add('active');
        }
    }

    // Refactored public methods using the helper function
    static handleActiveState(link = null) {
        this.handleActiveStateForNavLinks(Utils.NAV_LINKS, link);
    }

    static handleMobileActiveState(link = null) {
        this.handleActiveStateForNavLinks(Utils.MOB_NAV_LINKS, link);
    }


    // Step 2: Provide a static method to access the single instance
    static getInstance() {
        if (!SubPage.instance) {
            SubPage.instance = new SubPage();
        }
        return SubPage.instance;
    }

    // Step 3: Add method to get the current page
    static getCurrentPage() {
        return SubPage.currentPage;
    }

    static setCurrentPage(page) {
        SubPage.currentPage = page;
    }


}
